import { apiGet, apiPost } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IMeasureKnoChangeHistoryItem } from '../interfaces/IMeasureKnoChangeHistoryItem';
import { IMeasureNumberSearchItem } from '../interfaces/IMeasureNumberSearchItem';

export async function searchMeasuresByNumber(query: string): Promise<IMeasureNumberSearchItem[]> {
  const queryParams = new URLSearchParams();

  queryParams.append('query', query);

  return apiGet<IMeasureNumberSearchItem[]>(
    `${getServiceBaseURL(APIServiceEnum.KNM_SERVICE, false)}/measure-kno/search-measure?${queryParams}`,
  );
}

export async function changeKnoForMeasure(
  erpId: string,
  ervkVersionUuid: string,
  ervkUuid: string | undefined,
  changeReason: string,
  isErp: boolean,
): Promise<void> {
  const queryParams = new URLSearchParams();

  queryParams.append('erpId', erpId);
  queryParams.append('ervkVersionUuid', ervkVersionUuid);
  if (ervkUuid) {
    queryParams.append('ervkUuid', ervkUuid);
  }
  queryParams.append('changeReason', changeReason);

  return apiPost({
    url: `${getServiceBaseURL(APIServiceEnum.KNM_SERVICE, isErp)}/measure-kno/change-kno?${queryParams}`,
  });
}

export async function fetchMeasureHistoryChanges(): Promise<IMeasureKnoChangeHistoryItem[]> {
  return apiGet(`${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/measure-kno/change-kno-history`);
}
